import { PalettesProps } from '@ant-design/colors';
import { PaletteColorOptions } from '@mui/material/styles';
import { ThemeMode } from '~/types/config';
import { PaletteThemeProps } from '~/types/theme';

/*
 * The Flamingo theme was born out of a "back to basics" project code named "Flamingo". It
 * represents a intermediary step towards a more branded esthetic while we build a new
 * design system.
 */
const Flamingo = (colors: PalettesProps, mode: ThemeMode): PaletteThemeProps => {
  const { grey } = colors;
  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16],
  };
  const contrastText = '#fff';

  let primaryColors = [
    '#E8F1F8', // Lightest blue
    '#B3D6EC',
    '#7FBBE0',
    '#4BA1D4',
    '#2890CA',
    '#117EC0', // Base blue
    '#0E65A0',
    '#0B4D80',
    '#083660',
    '#051F40', // Darkest blue
  ];
  let errorColors = ['#FDE8E7', '#F25E52', '#F04134', '#EE3B2F', '#E92A21'];
  let warningColors = ['#FFF7E0', '#FFC926', '#FFBF00', '#FFB900', '#FFA900'];
  let infoColors = ['#FFF8E1', '#FFE57F', '#FFD740', '#FFC400', '#FFB300']; // Light to dark yellows
  let successColors = ['#E0F5EA', '#26B56E', '#00A854', '#00A04D', '#008D3A'];

  if (mode === ThemeMode.DARK) {
    primaryColors = [
      '#153fab',
      '#145fca',
      '#1370dd',
      '#0e82f0',
      '#0091ff',
      '#35a1ff', // Base blue
      '#5cb1ff',
      '#8cc7ff',
      '#badcff',
      '#e2f1ff',
    ];
    errorColors = ['#330b0c', '#992223', '#FF383B', '#ff8889', '#ffd7d8'];
    warningColors = ['#665200', '#997a00', '#cca300', '#FFCC00', '#ffd633'];
    infoColors = ['#665200', '#997a00', '#cca300', '#FFCC00', '#ffd633'];
    successColors = ['#0a2812', '#1f7735', '#34C759', '#85dd9b', '#d6f4de'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText,
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500]!,
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0],
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText,
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100],
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText,
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText,
    },
    grey: greyColors,
  };
};

export default Flamingo;
